import { render, staticRenderFns } from "./mvideo.vue?vue&type=template&id=2c990fac&scoped=true&"
import script from "./mvideo.vue?vue&type=script&lang=js&"
export * from "./mvideo.vue?vue&type=script&lang=js&"
import style0 from "./mvideo.vue?vue&type=style&index=0&id=2c990fac&scoped=true&lang=css&"
import style1 from "./mvideo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c990fac",
  null
  
)

export default component.exports